export const CLOSE_NAVIGATION = "CLOSE_NAVIGATION";
export const OPEN_NAVIGATION = "OPEN_NAVIGATION";
